<!-- T1005776厦门国际银行-存款达标领取活动-抽奖记录-行方app打开 -->
<template>
  <div>
    <MyHeader />
    <div class="xiame-bank-deposit-standard-records">
      <div class="title">领取记录</div>
      <img
        class="img1"
        :src="require(`@/assets/imgs/xiameBankDepositStandard/rule1.png`)"
        alt=""
      />
      <div class="content">
        <div class="header">
          <span class="text1">领取日期</span>
          <span class="text2">奖品</span>
          <!-- <span class="text3">操作</span> -->
        </div>
        <van-list
          v-model:loading="loading"
          :finished="finished"
          finished-text="没有更多了"
          :immediate-check="false"
          @load="myPrize"
          class="list"
        >
          <ul>
            <li
              v-for="item in list"
              :key="item.id"
              class="van-hairline--bottom"
            >
              <span class="text1">{{ item.createTimeShow }}</span>
              <span class="text2 van-ellipsis">{{ item.stockName }}</span>
            </li>
          </ul>
        </van-list>
      </div>
      <img
        class="img2"
        :src="require(`@/assets/imgs/xiameBankDepositStandard/rule3.png`)"
        alt=""
      />
    </div>
  </div>
</template>
<script>
import { getRecordPages } from '@/api/xibDepositStandard.js'
import { loginFun } from './components/community'
import moment from 'moment'
import MyHeader from './components/MyHeader.vue'
export default {
  components: { MyHeader },
  data() {
    return {
      title: '厦门国际银行',
      loading: false,
      finished: false,
      currentPage: 1,
      list: [
        // status", value = "领取状态 0未领取 1已领取")
      ]
    }
  },
  created() {
    if (sessionStorage.getItem('xiameBankXibSaveMoneyToken')) {
      this.currentPage = 1
      this.myPrize()
    } else {
      this.login()
    }
  },
  methods: {

    myPrize() {
      getRecordPages({
        pageNum: this.currentPage,
        pageSize: 30,
        param: {}
      }).then(res => {
        console.log('this.currentPage', this.currentPage);

        let { records, pages, current } = res.data
        records.map(i => {
          i.createTimeShow = moment(i.createTime).format('YYYY-MM-DD HH:mm')
        })
        this.list = current === 1 ? records : [...this.list, ...records]
        this.loading = false;
        if (pages <= current) {
          this.finished = true;
        }
        this.currentPage++
      })
    },
    async login() {
      await loginFun(this)
      this.myPrize()
    },

  },
}
</script>
<style lang="less" scoped>
.xiame-bank-deposit-standard-records {
  min-height: 100vh;
  font-size: 14px;
  padding: 55px 14px 15px 14px;
  background: #feecdf;
  box-sizing: border-box;
  position: relative;
  font-size: 0;

  .title {
    position: absolute;
    top: 63px;
    left: 0;
    width: 100%;
    text-align: center;
    font-size: 19px;
    font-weight: 800;
    color: #ffffff;
    text-shadow: 1px 1px 0px rgba(222, 14, 37, 0.34);
  }

  .img1,
  .img2 {
    width: 100%;
  }

  .content {
    background: url("../../../assets/imgs/xiameBankDepositStandard/rule2.png")
      repeat-Y;
    background-size: contain;
    padding: 20px 20px;
    font-size: 12px;
    color: #999999;
    // min-height: calc(100vh - 200px);
    margin-top: -3px;
  }

  .header {
    background: #fee9da;
    border-radius: 10px;
    font-size: 14px;
    color: #ce5923;
    line-height: 2.4;
    display: flex;
    align-items: center;
    justify-content: space-between;
    text-align: center;

    span {
      display: inline-block;
    }

    .text1,
    .text2 {
      width: 50%;
    }
  }

  .list {
    height: calc(100vh - 230px);
    overflow: auto;
    li {
      height: 50px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      // border-bottom: 1px solid #e6e6e6;
      padding-left: 25px;
      font-size: 12px;
    }

    span {
      display: inline-block;
    }

    .text1 {
      width: 130px;
      width: 50%;
    }

    .text2 {
      width: 50%;
      text-align: center;
      color: #822603;
    }
  }
  /deep/ .van-list__finished-text,
  .van-loading__text {
    font-size: 12px;
  }
}
</style>
